<template>
  <el-container class="page">
    <AppSidebar :active-menu.sync="activeMenu" />

    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i class="el-icon-circle-check"></i>
          <span class="header-title">票务核销</span>
        </div>

        <div class="header-right">
          <el-button type="primary" icon="el-icon-download" @click="onExport">导出核销数据</el-button>
          <el-button icon="el-icon-refresh" @click="onRefresh">刷新数据</el-button>
        </div>
      </el-header>

      <el-main class="main">
        <!-- 筛选区 -->
        <el-card shadow="never" class="filter-card">
          <el-form :inline="true" size="small" class="filter-form">
            <el-form-item label="核销状态：">
              <el-select v-model="filters.verifyStatus" placeholder="全部状态" style="width: 140px">
                <el-option label="全部状态" value="" />
                <el-option label="未核销" value="未核销" />
                <el-option label="已核销" value="已核销" />
              </el-select>
            </el-form-item>

            <el-form-item label="平台筛选：">
              <el-select v-model="filters.platform" placeholder="全部游客" style="width: 140px">
                <el-option label="全部游客" value="" />
                <el-option v-for="(p, idx) in platformOptions" :key="idx" :label="p" :value="p" />
              </el-select>
            </el-form-item>

            <el-form-item label="票种类型：">
              <el-select v-model="filters.ticketType" placeholder="全部类型" style="width: 140px">
                <el-option label="全部类型" value="" />
                <el-option v-for="(t, idx) in ticketTypeOptions" :key="idx" :label="t" :value="t" />
              </el-select>
            </el-form-item>
            
            <el-form-item label="渠道来源：">
              <el-select
                v-model="filters.channel"
                placeholder="全部渠道"
                style="width: 140px"
                :disabled="currentUserChannel !== ''"
              >
                <el-option label="全部渠道" value="" />
                <el-option v-for="(c, idx) in channelOptions" :key="idx" :label="c" :value="c" />
              </el-select>
            </el-form-item>

            <el-form-item label="游玩区域：">
              <el-select v-model="filters.area" placeholder="全部区域" style="width: 140px">
                <el-option label="全部区域" value="" />
                <el-option v-for="(a, idx) in areaOptions" :key="idx" :label="a" :value="a" />
              </el-select>
            </el-form-item>
            
            <el-form-item label="入园日期：">
              <!-- 入园日期改为下拉菜单，选项来源于系统设置中的 visitDates -->
              <el-select
                v-model="filters.visitDate"
                placeholder="选择入园日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates.filter(isFutureDate)"
                  :key="'visit-' + idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button class="clear-date-btn" @click="clearDate">清空日期</el-button>
            </el-form-item>
            <el-form-item label="历史查询：">
              <!-- 历史查询改为下拉菜单，选项来源于系统设置中的 visitDates -->
              <el-select
                v-model="historyDate"
                placeholder="选择历史日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates"
                  :key="'history-' + idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="applyHistory">历史查询</el-button>
            </el-form-item>

            <el-form-item label="订单号：">
              <el-input v-model="filters.orderNo" placeholder="输入订单号" style="width: 180px" />
            </el-form-item>
            
            <el-form-item label="证件号：">
              <el-input v-model="filters.idNo" placeholder="输入证件号" style="width: 180px" />
            </el-form-item>

            <el-form-item label="手机号：">
              <el-input v-model="filters.phone" placeholder="输入手机号" style="width: 160px" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="applyFilters">应用筛选</el-button>
              <el-button @click="resetFilters">清除筛选</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格区 -->
        <el-card shadow="never" class="table-card">
          <el-table
            :data="filteredData"
            stripe
            border
            height="70vh"
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#303133', fontWeight: 700 }"
            :cell-style="{ padding: '10px 0' }"
            empty-text=""
          >
            <el-table-column label="编号" type="index" width="60" />
            <el-table-column prop="orderNo" label="订单号" min-width="120" show-overflow-tooltip />
            <el-table-column prop="name" label="游客姓名" min-width="110" />
            <el-table-column prop="idNo" label="证件号码" min-width="170" show-overflow-tooltip />
            <el-table-column prop="phone" label="手机号" min-width="120" />
            <el-table-column prop="age" label="年龄" width="80" />
            <el-table-column prop="visitDate" label="入园日期" min-width="110" />
            <el-table-column prop="platform" label="观礼平台" min-width="110" />
            <el-table-column prop="ticketType" label="票种类型" min-width="100" />
            <el-table-column prop="area" label="游玩区域" min-width="100" />
            <el-table-column label="渠道来源" min-width="100">
              <template slot-scope="scope">
                {{ channelText(scope.row.channel) }}
              </template>
            </el-table-column>
            <el-table-column label="核销状态" min-width="100">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.verifyStatus === '已核销' ? 'success' : 'danger'"
                  effect="plain"
                >
                  {{ scope.row.verifyStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120" class-name="remark-cell" />
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.verifyStatus !== '已核销'"
                  type="text"
                  size="small"
                  @click="onVerify(scope.row)"
                >
                  核销
                </el-button>
                <el-button
                  v-if="scope.row.verifyStatus === '已核销'"
                  type="text"
                  size="small"
                  class="danger-text"
                  @click="onCancel(scope.row)"
                >
                  取消核销
                </el-button>
                <el-button type="text" size="small" @click="onRemark(scope.row)">备注</el-button>
                <el-button type="text" size="small" @click="onView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="filteredData.length === 0" class="empty">
            <div class="empty-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="empty-title">暂无游客数据</div>
            <div class="empty-sub">请前往“游客信息录入”页面添加数据</div>
          </div>

          <div class="pager">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              @size-change="onPageSizeChange"
              @current-change="onPageChange"
            />
          </div>
        </el-card>
      </el-main>
    </el-container>

    <!-- 详情弹窗 -->
    <el-dialog title="核销详情" :visible.sync="detailVisible" width="720px">
      <el-descriptions v-if="detailRow" :column="2" border>
        <el-descriptions-item label="订单号">{{ detailRow.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="游客姓名">{{ detailRow.name }}</el-descriptions-item>
        <el-descriptions-item label="证件号码">{{ detailRow.idNo }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailRow.phone }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{ detailRow.age }}</el-descriptions-item>
        <el-descriptions-item label="入园日期">{{ detailRow.visitDate }}</el-descriptions-item>
        <el-descriptions-item label="观礼平台">{{ detailRow.platform }}</el-descriptions-item>
        <el-descriptions-item label="票种类型">{{ detailRow.ticketType }}</el-descriptions-item>
        <el-descriptions-item label="游玩区域">{{ detailRow.area }}</el-descriptions-item>
        <el-descriptions-item label="渠道来源">{{ detailRow.channel }}</el-descriptions-item>
        <el-descriptions-item label="核销状态">
          <el-tag :type="detailRow && detailRow.verifyStatus === '已核销' ? 'success' : 'danger'" effect="plain">
            {{ detailRow && detailRow.verifyStatus }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="核销时间">{{ detailRow.verifiedAt || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailRow.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import AppSidebar from '../../components/AppSidebar.vue'
import { getVerifications, verifyVisitor, cancelVerification, getSettings } from '../../api'
import { PLATFORMS, PLATFORM_AREAS, TICKET_TYPES } from '../../config/platforms'
import { buildQuery, downloadByUrl } from '../../utils/download'
import { API_BASE } from '../../api/http'
import { channelText } from '../../utils/dicts'

export default {
  name: 'TicketVerifyPage',
  components: { AppSidebar },
  data() {
    return {
      activeMenu: '3',
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 20,
      currentUserRole: '',
      currentUserChannel: '',
      filters: {
        verifyStatus: '',
        platform: '',
        ticketType: '',
        channel: '',
        area: '',
        visitDate: '',
        orderNo: '',
        idNo: '',
        phone: ''
      },
      historyDate: '',
      historyDates: [],
      detailVisible: false,
      detailRow: null
      ,
      // options from system settings
      platformOptions: [],
      ticketTypeOptions: [],
      channelOptions: [],
      areaOptions: []
    }
  },
  computed: {
    filteredData() {
      // 后端已支持筛选，这里直接展示 tableData；保留 computed 以兼容模板字段
      return this.tableData
    }
  },
  created() {
    this.loadCurrentUser()
    this.loadData()
    this.loadSettings()
  },
  methods: {
    loadCurrentUser() {
      const AUTH_KEY = 'yy_auth'
      try {
        const raw = localStorage.getItem(AUTH_KEY)
        const auth = raw ? JSON.parse(raw) : null
        const user = auth && auth.user ? auth.user : null
        if (user) {
          this.currentUserRole = user.role || ''
          // 如果是票务核销员，自动设置渠道来源筛选
          if (this.currentUserRole === '票务核销员') {
            this.currentUserChannel = user.channel || ''
            if (this.currentUserChannel) {
              this.filters.channel = this.currentUserChannel
            }
          } else {
            this.currentUserChannel = ''
          }
        }
      } catch (e) {
        // ignore
      }
    },
    async loadSettings() {
      try {
        const data = await getSettings()
        const visitor = (data && data.visitor) || {}
        this.historyDates = visitor.visitDates || []
        if (this.historyDates.length > 0 && !this.historyDate) this.historyDate = this.historyDates[0]

        // 平台与游玩区域按需求写死，不使用后端数据
        this.platformOptions = PLATFORMS.slice()

        // 票种类型写死为 TICKET_TYPES（与录入页同步）
        this.ticketTypeOptions = TICKET_TYPES.slice()
        // 渠道选项从后端设置读取（若未配置则为空）
        this.channelOptions = Array.isArray(visitor.channelOptions) ? visitor.channelOptions : (visitor.channelOptions || [])

        // 如果是票务核销员，使用账号分配的渠道（如果有的话）作为筛选
        if (this.currentUserChannel) {
          this.filters.channel = this.currentUserChannel
          // 同时也用账号分配的平台作为筛选（如果还没设置的话）
          if (this.currentUserRole === '票务核销员') {
            const AUTH_KEY = 'yy_auth'
            try {
              const raw = localStorage.getItem(AUTH_KEY)
              const auth = raw ? JSON.parse(raw) : null
              const user = auth && auth.user ? auth.user : {}
              if (user.platform) {
                this.filters.platform = user.platform
              }
            } catch (e) {
              // ignore
            }
          }
        }

        // areaOptions 展示为所有平台下的并集（用于筛选下拉）
        this.areaOptions = []
        Object.keys(PLATFORM_AREAS).forEach(p => {
          const arr = PLATFORM_AREAS[p] || []
          this.areaOptions.push(...arr)
        })
        this.areaOptions = Array.from(new Set(this.areaOptions))
      } catch (e) {
        this.historyDates = []
        this.platformOptions = PLATFORMS.slice()
        this.ticketTypeOptions = TICKET_TYPES.slice()
        this.areaOptions = Object.keys(PLATFORM_AREAS).reduce((acc, p) => acc.concat(PLATFORM_AREAS[p] || []), [])
      }
    },
    formatHistoryLabel(d) {
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return d
        const y = dt.getFullYear()
        const m = String(dt.getMonth() + 1).padStart(2, '0')
        const day = String(dt.getDate()).padStart(2, '0')
        return `${y}.${m}.${day}`
      } catch (e) {
        return d
      }
    },
    isFutureDate(d) {
      // 判断日期是否为当前日期及以后
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return false
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        dt.setHours(0, 0, 0, 0)
        return dt >= today
      } catch (e) {
        return false
      }
    },
    disabledHistoryDate(date) {
      if (!date) return true
      try {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const s = `${y}/${m}/${d}`
        return !(this.historyDates || []).includes(s)
      } catch (e) {
        return true
      }
    },
    applyHistory() {
      if (!this.historyDate) {
        this.$message.warning('请先选择历史日期')
        return
      }
      this.filters.visitDate = this.historyDate
      this.page = 1
      this.loadData()
    },
    channelText,
    onPageChange(p) {
      this.page = p
      this.loadData()
    },
    onPageSizeChange(ps) {
      this.pageSize = ps
      this.page = 1
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const data = await getVerifications({
          verifyStatus: this.filters.verifyStatus,
          platform: this.filters.platform,
          ticketType: this.filters.ticketType,
          channel: this.filters.channel,
          area: this.filters.area,
          visitDate: this.filters.visitDate,
          orderNo: this.filters.orderNo,
          idNo: this.filters.idNo,
          phone: this.filters.phone,
          page: this.page,
          pageSize: this.pageSize
        })
        this.tableData = data.list || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    clearDate() {
      this.filters.visitDate = ''
    },
    async applyFilters() {
      this.page = 1
      await this.loadData()
      this.$message.success('已应用筛选')
    },
    async resetFilters() {
      this.filters = {
        verifyStatus: '',
        platform: this.currentUserChannel && this.currentUserRole === '票务核销员' ? this.filters.platform : '',
        ticketType: '',
        channel: this.currentUserChannel || '',
        area: '',
        visitDate: '',
        orderNo: '',
        idNo: '',
        phone: ''
      }
      this.page = 1
      await this.loadData()
    },
    onExport() {
      const url = `${API_BASE}/api/export/verifications.csv${buildQuery(this.filters)}`
      downloadByUrl(url)
    },
    async onRefresh() {
      await this.loadData()
      this.$message.success('已刷新')
    },
    onView(row) {
      this.detailRow = row
      this.detailVisible = true
    },
    onVerify(row) {
      this.$confirm('确认核销该游客？', '提示', { type: 'warning' })
        .then(async () => {
          await verifyVisitor(row.visitorId, '')
          await this.loadData()
          this.$message.success('核销成功')
        })
        .catch(() => {})
    },
    onCancel(row) {
      this.$confirm('确认取消该游客的核销？', '提示', { type: 'warning' })
        .then(async () => {
          await cancelVerification(row.visitorId)
          await this.loadData()
          this.$message.success('已取消核销')
        })
        .catch(() => {})
    }
    ,
    async onRemark(row) {
      try {
        const defaultVal = row.remark || ''
        const res = await this.$prompt('请输入备注内容', '填写备注', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          inputPlaceholder: '例如：客户要求改签/备注信息',
          inputValue: defaultVal
        })
        const value = (res && res.value) || ''
        // call API to update remark (new endpoint)
        const { updateVerificationRemark } = await import('../../api')
        await updateVerificationRemark(row.visitorId, value || '')
        await this.loadData()
        this.$message.success('备注已保存')
      } catch (e) {
        // prompt cancel throws, ignore
        if (e && e.message) {
          // if not cancellation, show error
          if (e.message !== 'cancel') {
            this.$message.error(e.message || '保存备注失败')
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.page {
  height: 100vh;
  background: #f5f7fa;
}

.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #303133;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
}

.main {
  padding: 16px;
}

.filter-card {
  margin-bottom: 16px;
}

.filter-form ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 10px;
}

.clear-date-btn {
  width: 72px;
  height: 32px;
  padding: 0 10px;
  line-height: 32px;
  border-radius: 4px;
  border: none;
  color: #fff;
  background: #606266;
  white-space: nowrap;
}

.clear-date-btn:hover {
  background: #4e5258;
}

.table-card {
  position: relative;
}

.pager {
  padding: 12px 0 4px;
  display: flex;
  justify-content: flex-end;
}

.empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-10%);
  text-align: center;
  color: #909399;
}

.empty-icon {
  font-size: 56px;
  color: #dcdfe6;
}

.empty-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
}

.empty-sub {
  margin-top: 6px;
  font-size: 12px;
}

/* 备注列允许内换行显示完整文本 */
::v-deep td.remark-cell {
  white-space: normal !important;
  word-break: break-word !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
